module.exports = __webpack_public_path__ + "static/media/sale.ea554464.png";